module.exports = __webpack_public_path__ + "img/IMG_2440.63ebad49.jpg";